/**
 * Created by admin on 2017/1/19.
 */
import { _get, _post, _postNoEncrypt, _postJson, _postAes, _postNoEncryptAes } from '@/utils/http';
import { encryptAllRsa, decryptAes } from '@/utils/encrypt';
import storage from '@/utils/storage';

export const checkMobile = (mobile) => {
    // console.log(' mobile= ' + mobile);
    var url = '/insurance-web/users/userMobileVerify';
    return _post(url, { 'mobile': mobile });
};


export const register = (mobile, password, smsCode, inviteId, activityName) => {
    // console.log('注册成功');
    var url = '/insurance-web/users/userRegisterService';
    let invite = sessionStorage.getItem('gatewayInviteCode');
    let channelCode = sessionStorage.getItem('channelCode');
    if (invite) {
        return new Promise((resolve,reject)=>{
            _postNoEncryptAes(url, {
                'mobile': encryptAllRsa(mobile),
                'password': encryptAllRsa(password),
                'code': encryptAllRsa(smsCode),
                'inviteId': encryptAllRsa(inviteId),
                'inviteCode': encryptAllRsa(invite),
                'channelCode': encryptAllRsa(channelCode),
                'activity': encryptAllRsa(activityName)
            }).then(async res=>{
                res = JSON.parse(await decryptAes(res.encryptionData));
                resolve(res);
            }).catch(reject);
        });
    } else {
        return new Promise((resolve,reject)=>{
            _postNoEncryptAes(url, {
                'mobile': encryptAllRsa(mobile),
                'password': encryptAllRsa(password),
                'code': encryptAllRsa(smsCode),
                'inviteId': encryptAllRsa(inviteId),
                'channelCode': encryptAllRsa(channelCode),
                'activity': encryptAllRsa(activityName)
            }).then(async res=>{
                res = JSON.parse(await decryptAes(res.encryptionData));
                resolve(res);
            }).catch(reject);
        });
    }

};

export const login = (mobile, password, isRadioed, activityId, loginType='1') => {
    var url = '/insurance-web/users/userLogin';
    let invite = sessionStorage.getItem('gatewayInviteCode');
    let channelCode = sessionStorage.getItem('channelCode');
    if (isRadioed && typeof isRadioed != 'undefined') {
        return new Promise((resolve,reject) =>{
            _postNoEncryptAes(url, {
                'mobile': encryptAllRsa(mobile),
                'password': encryptAllRsa(password),
                'isAuthorized': encryptAllRsa('Y'),
                'inviteCode': encryptAllRsa(invite),
                'channelCode': encryptAllRsa(channelCode),
                'activity': encryptAllRsa(activityId),
                'loginType':encryptAllRsa(loginType)
            }).then(async res=>{
                res = JSON.parse(await decryptAes(res.encryptionData));
                resolve(res);
            }).catch(reject);
        });
    } else {
        return new Promise((resolve,reject) =>{
            _postNoEncryptAes(url, {
                'mobile': encryptAllRsa(mobile),
                'password': encryptAllRsa(password),
                'inviteCode': encryptAllRsa(invite),
                'channelCode': encryptAllRsa(channelCode),
                'activity': encryptAllRsa(activityId),
                'loginType':encryptAllRsa(loginType)
            }).then(async res=>{
                res = JSON.parse(await decryptAes(res.encryptionData));
                resolve(res);
            }).catch(reject);
        });
    }
};

export const sendSms = (mobile, type, imgCode) => {
    var url = '/insurance-web/captcha/smsSend';
    return _post(url, { 'phone': mobile, 'function': type, 'captchaReceived': imgCode });
};

// 手机号验证是否注册
export const userMobileVerify = (mobile) => {
    var url = '/insurance-web/users/userMobileVerify';
    return _post(url, { 'mobile': mobile });
};
// 设置密码/忘记密码
export const userSetPassword = ({ mobile, newPassword, type, smsCode, requestToken }) => {
    var url = '/insurance-web/users/userSetPassword';
    // return _postJson(url, { 'mobile': mobile, 'newPassword': newPassword, 'type': type, 'smsCode': smsCode, 'requestToken': requestToken });
    return _postNoEncrypt(url, {
        'mobile': encryptAllRsa(mobile),
        'newPassword': encryptAllRsa(newPassword),
        'type': encryptAllRsa(type),
        'requestToken': encryptAllRsa(requestToken)
    });
};
//获取短信验证码
export const smsSend = (mobile, type, imgCode) => {
    var url = '/insurance-web/users/smsSend';
    return new Promise((resolve,reject) =>{
        _postAes(url, { 'mobile': mobile, 'type': type, 'imgCode': imgCode }).then (async res=>{
            res = JSON.parse(await decryptAes(res.encryptionData));
            resolve(res);
        }).catch(reject);
    });
};
// 短信验证码注册
export const userRegisterService = ({ mobile, inviteId = '', invitePassUserId = '', inviteUserMobile = '', inviteCode = '', channelCode = '', activity = '', smsCode, requestToken }) => {
    var url = '/insurance-web/users/userRegisterService';
    return new Promise((resolve,reject) =>{
        _postNoEncryptAes(url, {
            'mobile': encryptAllRsa(mobile),
            'inviteId': encryptAllRsa(inviteId),
            'invitePassUserId': encryptAllRsa(invitePassUserId),
            'inviteUserMobile': encryptAllRsa(inviteUserMobile),
            'inviteCode': encryptAllRsa(inviteCode),
            'channelCode': encryptAllRsa(channelCode),
            'activity': encryptAllRsa(activity),
            'smsCode': encryptAllRsa(smsCode),
            'requestToken': encryptAllRsa(requestToken),
        }).then(async res=>{
            res = JSON.parse(await decryptAes(res.encryptionData));
            resolve(res);
        }).catch(reject);
    });
};
//用户登陆
export const userLogin = ({ mobile, password = '', isAuthorized = 'N', invitePassUserId = '', inviteUserMobile = '', inviteUserCenterId = '', inviteUserChannel = '', inviteCode = '', channelCode = '', activity = '', loginType, smsCode = '', requestToken = '' }) => {
    var url = '/insurance-web/users/userLogin';
    return new Promise((resolve,reject) =>{
        _postNoEncryptAes(url, {
            'mobile': encryptAllRsa(mobile),
            'password': encryptAllRsa(password),
            'isAuthorized': encryptAllRsa(isAuthorized),
            'invitePassUserId': encryptAllRsa(invitePassUserId),
            'inviteUserMobile': encryptAllRsa(inviteUserMobile),
            'inviteUserCenterId': encryptAllRsa(inviteUserCenterId),
            'inviteUserChannel': encryptAllRsa(inviteUserChannel),
            'inviteCode': encryptAllRsa(inviteCode),
            'channelCode': encryptAllRsa(channelCode),
            'activity': encryptAllRsa(activity),
            'loginType': encryptAllRsa(loginType),
            'smsCode': encryptAllRsa(smsCode),
            'requestToken': encryptAllRsa(requestToken)
        }).then(async res=>{
            res = JSON.parse(await decryptAes(res.encryptionData));
            resolve(res);
        }).catch(reject);
    });
};

//短信验证码校验
export const smsCheck = ({ mobile, smsCode, type , requestToken }) => {
    var url = '/insurance-web/users/smsCheck';
    return _post(url, { 'mobile': mobile, 'type': type, 'smsCode': smsCode, 'requestToken': requestToken });
};
//修改密码
export const userUpdatePassword = ({ mobile, newPassword, type , requestToken }) => {
    var url = '/insurance-web/users/userUpdatePassword';
    return _postNoEncrypt(url, {
        'mobile': encryptAllRsa(mobile),
        'type': encryptAllRsa(type),
        'newPassword': encryptAllRsa(newPassword),
        'requestToken': encryptAllRsa(requestToken)
    });
};

export const checkSmsVerifiCode = (mobile, smsVerifiCode, type) => {
    // console.log('检验短信验证码');
    var url = '/insurance-web/captcha/smsCheck';
    return _post(url, { 'phone': mobile, 'code': smsVerifiCode, 'function': type });
};

export const checkImgVerifiCode = (mobile, imgVerifiCode) => {
    // console.log('检验图片验证码');
    var url = '/insurance-web/captcha/captchaImgCheck';
    return _post(url, { 'captchaReceived': imgVerifiCode, 'phone': mobile });
};

export const loginOut = () => {
    var url = '/insurance-web/users/userLoginOut';
    return _get(url);
};

export const forgotSmsSend = (mobile, imgCode) => {
    var url = '/insurance-web/users/userPasswordResetGetCode';
    return _post(url, { 'mobile': mobile, 'captchaReceived': imgCode });
};

export const resetPwd = (mobile, verifyCode, newPassword) => {
    var url = '/insurance-web/users/userPasswordReset';
    return _post(url, { 'mobile': mobile, 'verifyCode': verifyCode, 'newPassword': newPassword });
};


export const isLogin = () => {
    let url = '/insurance-web/users/getUser';
    return new Promise((resolve, reject) => {
        _postAes(url).then(async res => {
            res = JSON.parse(await decryptAes(res.encryptionData));
            if (res.success) {
                // alert(res.data.accessToken);
                if (res.data.idStr) {
                    storage.setL('inviterOwn', res.data.idStr);
                    storage.set('inviterOwn', res.data.idStr);
                } else {
                    localStorage.removeItem('inviterOwn');
                    sessionStorage.removeItem('inviterOwn');
                }
                if (res.data.accessToken) {
                    sessionStorage['accessToken'] = res.data.accessToken;
                }
            }
            resolve(res);
        }).catch(reject);
    });
};

export const bindAccount = (mobile, code) => {
    let url = '/insurance-web/users/userBindApi';
    return _post(url, { 'mobile': mobile, 'code': code });
};

//代理人token 置换 登录态
export const tokenChangeLogin = (token) => {
    let url = '/insurance-web/users/replaceToken';
    return _post(url, { 'token': token });
};

// 从美云宝跳转过来置换 token
// export const tokenLoginChange = (token) =>{
//     let url = '/insurance-web/meinstech/tokenExchange';
//     return _post(url, { 'token' : token });
// };

// 从美云宝跳转过来置换 passId
export const tokenLoginChange = (passId) =>{
    let url = '/insurance-web/meinstech/passIdExchange';
    return _post(url, { 'passId' : passId });
};

// 判断美云宝分销人是不是师傅
export const isMaster = (mobile) =>{
    let url = '/insurance-web/meinstech/meiUserQuery';
    return _post(url, { 'mobile' : mobile });
};

/**
 * 通过appToken获取登录信息
 * @param token
 * @returns {Promise}
 */
export const getSessionByToken = (accessToken) => {
    let url = '/insurance-web/session/exchange';
    return _post(url, { 'token': accessToken });
};


/**
 * 短链接获取地址
 * @param token
 * @returns {Promise}
 */
export const getFullPath = (code) => {
    let url = '/insurance-web/short/getUrl?code=' + code;
    return _get(url);
};

/**
 *  保险融合关联手机号
 */
export const sendPlusSms = (mobile) => {
    var url = '/insurance-web/user/plus/sendAuthCodeByPass';
    return _post(url, { 'mobile': mobile });
};

/**
 *  保险融合关联手机号
 */
export const plusBindMobile = (code) => {
    var url = '/insurance-web/user/plus/bindMobile';
    return _post(url, { 'code': code });
};





// WEBPACK FOOTER //
// ./src/api/login.js